export default __webpack_public_path__ + "static/media/ESI.54dc5f66.jpg";